import React, { useState, useEffect } from 'react';
import {
  NavLink, Route, Switch, useLocation, useRouteMatch,
} from 'react-router-dom';

import ConsortiumItem from './ConsortiumItem';
import BackBtn from '../components/UI/BackBtn';
import api from '../api';
import Page from '../components/_layout/Page';
import WidgetsGrid from '../components/_layout/WidgetsGrid';

export default function Consortiums() {
  const { path, url } = useRouteMatch();
  const location = useLocation();

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [consortiums, setConsortiums] = useState([]);

  useEffect(async () => {
    try {
      const response = await api.get('/info/consortiums');
      const newConsortiums = response.map((c) => ({
        url: `/consortiums/${c.id}`,
        name: c.name,
      }));
      setConsortiums(newConsortiums);
      setIsLoaded(true);
    } catch (error) {
      setIsLoaded(true);
      setError(error);
    }
  }, []);

  if (error) {
    return (
      <div style={{ color: 'red', background: 'white' }}>
        Ошибка:
        {error.message}
      </div>
    );
  } if (!isLoaded) {
    return <section className="page projects-page"><div className="container"><div>Загрузка...</div></div></section>;
  }
  return (
    <div>
      {location.pathname === '/consortiums'
        ? (
          <Page header="Консорциумы" className="consortiums-page">
            <WidgetsGrid items={consortiums} />
          </Page>
        )
        : (
          <Page className="consortium-item-page">
            <BackBtn />
            <Switch>
              <Route path={`${path}/:consortiumId`}>
                <ConsortiumItem data={consortiums} />
              </Route>
            </Switch>
          </Page>
        )}
    </div>
  );
}
